import React from 'react'
import { useTranslation } from 'react-i18next'
import { Controller } from 'react-hook-form'
import {
  Box,
  Typography,
  Grid,
  TextField,
  IconButton,
  InputAdornment
} from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'

const EmailInformationFields = ({ control, errors, isPasswordShown, onTogglePassword }) => {
  const { t } = useTranslation()

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="subtitle1" sx={{ mb: 2.5, color: 'text.primary' }}>
        {t('mailTemplate.users.modal.emailInformation')}
      </Typography>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Controller
            name="emailUserName"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                variant="outlined"
                size="small"
                label={t('mailTemplate.users.modal.emailUserName')}
                placeholder={t('mailTemplate.users.modal.emailUserNameP')}
                {...(errors.emailUserName && {
                  error: true,
                  helperText: t('mailTemplate.users.modal.errors.emailUserName')
                })}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="emailPassword"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                variant="outlined"
                size="small"
                label={t('mailTemplate.users.modal.emailPassword')}
                placeholder={t('mailTemplate.users.modal.emailPasswordP')}
                type={isPasswordShown ? 'text' : 'password'}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        edge="end"
                        onClick={onTogglePassword}
                        onMouseDown={(e) => e.preventDefault()}
                        aria-label="toggle password visibility"
                      >
                        {isPasswordShown ? <VisibilityOffIcon/> : <VisibilityIcon/>}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
                {...(errors.emailPassword && {
                  error: true,
                  helperText: t('mailTemplate.users.modal.errors.emailPassword')
                })}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="inboxFolderName"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                variant="outlined"
                size="small"
                label={t('mailTemplate.users.modal.inboxFolderName')}
                placeholder={t('mailTemplate.users.modal.inboxFolderNameP')}
                {...(errors.inboxFolderName && {
                  error: true,
                  helperText: t('mailTemplate.users.modal.errors.inboxFolderName')
                })}
              />
            )}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default EmailInformationFields
